<template>
  <div class="warp">
    <div class="enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">研发攻关</div>
        <div class="img_desc hidden-xs-only">
          以研发破氢能难题，用攻坚绘低碳蓝图
        </div>
        <div class="img_tit hidden-sm-and-up">
          以研发破氢能难题<br />用攻坚绘低碳蓝图
        </div>
      </div>
    </div>
    <div class="desc">
      提炼并解决氢能“制储输用”核心装备及中试共性关键技术 ，推动氢能产业化进程
    </div>
    <div class="cooperation_box">
      <div class="warp">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="img_box">
            <img :src="item.img" alt="" />
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          img: require("@/assets/run1.png"),
          title: "关键材料",
        },
        {
          img: require("@/assets/run2.png"),
          title: "核心工艺",
        },
        {
          img: require("@/assets/run3.png"),
          title: "智能系统",
        },
        {
          img: require("@/assets/run4.png"),
          title: "燃料电池",
        },
        {
          img: require("@/assets/run5.png"),
          title: "电解水制氢",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/rad.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.warp {
  width: 100%;
  .header {
    width: 100%;
    position: relative;
    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 5vh;
      color: #fff;
      font-weight: 700;
    }
    img {
      width: 100vw;
      height: 40vh;
      object-fit: cover;
    }
  }
  .desc {
    width: 100%;
    text-align: center;
    font-size: 3vh;
    color: #47a2ff;
    font-weight: 700;
    margin: 20px 0;
    @media screen and (max-width: 768px) {
      font-size: 0.85rem;
      padding: 20px 20px;
    }
  }
  .cooperation_box {
    width: 90%;
    margin: 0 auto;
    padding-top: 50px;
    position: relative;
    .warp {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 16%;
        background: #fff;
        border-radius: 20px;
        box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
        overflow: hidden;
        transition: all 0.3s;
        @media screen and (max-width: 768px) {
          width: 30%;
          margin-bottom: 10px;
        }
        &:hover {
          transform: scale(1.05);
        }
        img {
          width: 100%;
          height: 200px;
          @media screen and (max-width: 768px) {
            height: 80px;
          }
        }
        .title {
          padding: 5px 0;
          font-size: 15px;
          font-weight: 600;
          text-align: center;
        }
      }
    }
  }
}
</style>